var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 15.5417H3.95833V4.45833H9.5V2.875H3.95833C3.07958 2.875 2.375 3.5875 2.375 4.45833V15.5417C2.375 16.4125 3.07958 17.125 3.95833 17.125H15.0417C15.9125 17.125 16.625 16.4125 16.625 15.5417V10H15.0417V15.5417ZM11.0833 2.875V4.45833H13.9254L6.14333 12.2404L7.25958 13.3567L15.0417 5.57458V8.41667H16.625V2.875H11.0833Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWindow);
export default __webpack_public_path__ + "static/media/new_window.4dd9b4f185f23cb32a2424fcb19a5045.svg";
export { ForwardRef as ReactComponent };